import { IPostFormInitialState } from '../../components/Feed/reducer/reducer';
import {
    IAudition,
    ICastingDirector,
    IContestWatchList,
    ILocation,
    ISavedAudition,
    IRole as IRoleData,
    IProject,
    IWorkProfile,
    IPaginator,
    IRole,
    IRoleCreator,
} from '../../types/global/helper';
import { FilingStatus, IApplication } from '../../types/global/ListRender.types';
import { FormOption } from '../appConfigurator/types';

export const types = {
    GET_ALL_AUDITIONS: 'GET_ALL_AUDITIONS',
    GET_ALL_AUDITION_SUCCESS: 'GET_ALL_AUDITION_SUCCESS',
    GET_ALL_AUDITION_FAILED: 'GET_ALL_AUDITION_FAILED',

    GET_AUDITION_DETAIL: 'GET_AUDITION_DETAIL',
    GET_AUDITION_DETAIL_SUCCESS: 'GET_AUDITION_DETAIL_SUCCESS',
    GET_AUDITION_DETAIL_FAILED: 'GET_AUDITION_DETAIL_FAILED',

    APPLY_TO_AUDITION: 'APPLY_TO_AUDITION',
    APPLY_TO_AUDITION_SUCCESS: 'APPLY_TO_AUDITION_SUCCESS',
    APPLY_TO_AUDITION_FAILED: 'APPLY_TO_AUDITION_FAILED',

    ADD_AUDITION_TO_WATCHLIST: 'ADD_AUDITION_TO_WATCHLIST',
    ADD_AUDITION_TO_WATCHLIST_SUCCESS: 'ADD_AUDITION_TO_WATCHLIST_SUCCESS',
    ADD_AUDITION_TO_WATCHLIST_FAILED: 'ADD_AUDITION_TO_WATCHLIST_FAILED',

    GET_ROLES: 'GET_ROLES',
    GET_ROLES_SUCCESS: 'GET_ROLES_SUCCESS',
    GET_ROLES_FAILED: 'GET_ROLES_FAILED',

    UPDATE_ROLE: 'UPDATE_ROLE',
    UPDATE_ROLE_SUCCESS: 'UPDATE_ROLE_SUCCESS',
    UPDATE_ROLE_FAIL: 'UPDATE_ROLE_FAIL',

    GET_MY_APPLICATIONS: 'GET_MY_APPLICATIONS',
    GET_MY_APPLICATIONS_SUCCESS: 'GET_MY_APPLICATIONS_SUCCESS',
    GET_MY_APPLICATIONS_FAILED: 'GET_MY_APPLICATIONS_FAILED',

    TOGGLE_FILTER: 'SHOW_FILTER',
    ADD_FILTER: 'ADD_FILTER',
    REMOVE_FILTER: 'REMOVE_FILTER',

    SAVE_COLLECTION: 'SAVE_COLLECTION',
    SAVE_COLLECTION_SUCCESS: 'SAVE_COLLECTION_SUCCESS',
    SAVE_COLLECTION_FAIL: 'SAVE_COLLECTION_FAIL',

    GET_SAVED_COLLECTION: 'GET_SAVED_COLLECTION',
    GET_SAVED_COLLECTION_SUCCESS: 'GET_SAVED_COLLECTION_SUCCESS',
    GET_SAVED_COLLECTION_FAIL: 'GET_SAVED_COLLECTION_FAIL',

    DELETE_SAVED_COLLECTION: 'DELETE_SAVED_COLLECTION',
    DELETE_SAVED_COLLECTION_SUCCESS: 'DELETE_SAVED_COLLECTION_SUCCESS',
    DELETE_SAVED_COLLECTION_FAIL: 'DELETE_SAVED_COLLECTION_FAIL',

    UPDATE_SAVED_COLLECTION: 'UPDATE_SAVED_COLLECTION',
    UPDATE_SAVED_COLLECTION_SUCCESS: 'UPDATE_SAVED_COLLECTION_SUCCESS',
    UPDATE_SAVED_COLLECTION_FAIL: 'UPDATE_SAVED_COLLECTION_FAIL',

    CREATE_AUDITION: 'CREATE_AUDITION',
    CREATE_AUDITION_SUCCESS: 'CREATE_AUDITION_SUCCESS',
    CREATE_AUDITION_FAIL: 'CREATE_AUDITION_FAIL',

    CREATE_ROLE: 'CREATE_ROLE',
    CREATE_ROLE_SUCCESS: 'CREATE_ROLE_SUCCESS',
    CREATE_ROLE_FAIL: 'CREATE_ROLE_FAIL',

    UPDATE_AUDITION: 'UPDATE_AUDITION',
    UPDATE_AUDITION_SUCCESS: 'UPDATE_AUDITION_SUCCESS',
    UPDATE_AUDITION_FAIL: 'UPDATE_AUDITION_FAIL',

    SET_AUDITION_FOR_EDIT: 'SET_AUDITION_FOR_EDIT',

    DELETE_ROLE: 'DELETE_ROLE',
    DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
    DELETE_ROLE_FAIL: 'DELETE_ROLE_FAIL',

    PUBLISH_AUDITION: 'PUBLISH_AUDITION',
    PUBLISH_AUDITION_SUCCESS: 'PUBLISH_AUDITION_SUCCESS',
    PUBLISH_AUDITION_FAIL: 'PUBLISH_AUDITION_FAIL',

    UNPUBLISH_AUDITION: 'UNPUBLISH_AUDITION',
    UNPUBLISH_AUDITION_SUCCESS: 'UNPUBLISH_AUDITION_SUCCESS',
    UNPUBLISH_AUDITION_FAIL: 'UNPUBLISH_AUDITION_FAIL',

    DELETE_AUDITION: 'DELETE_AUDITION',
    DELETE_AUDITION_SUCCESS: 'DELETE_AUDITION_SUCCESS',
    DELETE_AUDITION_FAIL: 'DELETE_AUDITION_FAIL',

    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',

    SET_AUDITION_TO_MANAGE: 'SET_AUDITION_TO_MANAGE',
    SET_APPLICATIONS_TO_MANAGE: 'SET_APPLICATIONS_TO_MANAGE',

    GET_ALL_APPLICATION_FOR_AUDITION: 'GET_ALL_APPLICATION_FOR_AUDITION',
    GET_ALL_APPLICATION_FOR_AUDITION_SUCCESS: 'GET_ALL_APPLICATION_FOR_AUDITION_SUCCESS',
    GET_ALL_APPLICATION_FOR_AUDITION_FAIL: 'GET_ALL_APPLICATION_FOR_AUDITION_FAIL',

    SORT_APPLICATION: 'SORT_APPLICATION',
    SORT_APPLICATION_SUCCESS: 'SORT_APPLICATION_SUCCESS',
    SORT_APPLICATION_FAIL: 'SORT_APPLICATION_FAIL',

    SET_AUDITION_DETAILS: 'SET_AUDITION_DETAILS',

    FILTER_AUDITION: 'FILTER_AUDITION',
    FILTER_AUDITION_SUCCESS: 'FILTER_AUDITION_SUCCESS',
    FILTER_AUDITION_FAIL: 'FILTER_AUDITION_FAIL',

    ADVANCED_AUDITION_SEARCH: 'ADVANCED_AUDITION_SEARCH',
    ADVANCED_AUDITION_SEARCH_SUCCESS: 'ADVANCED_AUDITION_SEARCH_SUCCESS',
    ADVANCED_AUDITION_SEARCH_FAIL: 'ADVANCED_AUDITION_SEARCH_FAIL',

    LOAD_MORE_AUDITIONS: 'LOAD_MORE_AUDITIONS',
    LOAD_MORE_AUDITIONS_SUCCESS: 'LOAD_MORE_AUDITIONS_SUCCESS',
    LOAD_MORE_AUDITIONS_FAIL: 'LOAD_MORE_AUDITIONS_FAIL',

    WITHDRAW_APPLICATION: 'WITHDRAW_APPLICATION',
    WITHDRAW_APPLICATION_SUCCESS: 'WITHDRAW_APPLICATION_SUCCESS',
    WITHDRAW_APPLICATION_FAIL: 'WITHDRAW_APPLICATION_FAIL',
    RESET_AUDTION_DATA: 'RESET_AUDTION_DATA',

    GET_SIMILAR_AUDITION: 'GET_SIMILAR_AUDITION',
    GET_SIMILAR_AUDITION_SUCCESS: 'GET_SIMILAR_AUDITION_SUCCESS',
    GET_SIMILAR_AUDITION_FAIL: 'GET_SIMILAR_AUDITION_FAIL',

    GET_CASTING_DIRECTOR: 'GET_CASTING_DIRECTOR',
    GET_CASTING_DIRECTOR_SUCCESS: 'GET_CASTING_DIRECTOR_SUCCESS',
    GET_CASTING_DIRECTOR_FAIL: 'GET_CASTING_DIRECTOR_FAIL',

    CREATE_CASTING_DIRECTOR: 'CREATE_CASTING_DIRECTOR',
    CREATE_CASTING_DIRECTOR_SUCCESS: 'CREATE_CASTING_DIRECTOR_SUCCESS',
    CREATE_CASTING_DIRECTOR_FAIL: 'CREATE_CASTING_DIRECTOR_FAIL',

    UPDATE_CASTING_DIRECTOR: 'UPDATE_CASTING_DIRECTOR',
    UPDATE_CASTING_DIRECTOR_SUCCESS: 'UPDATE_CASTING_DIRECTOR_SUCCESS',
    UPDATE_CASTING_DIRECTOR_FAIL: 'UPDATE_CASTING_DIRECTOR_FAIL',

    DELETE_CASTING_DIRECTOR: 'DELETE_CASTING_DIRECTOR',
    DELETE_CASTING_DIRECTOR_SUCCESS: 'DELETE_CASTING_DIRECTOR_SUCCESS',
    DELETE_CASTING_DIRECTOR_FAIL: 'DELETE_CASTING_DIRECTOR_FAIL',

    SET_ROLE: 'SET_ROLE',

    SET_AUDITION: 'SET_AUDITION',

    MANAGE_AUDITION: 'MANAGE_AUDITION',
    MANAGE_AUDITION_SUCCESS: 'MANAGE_AUDITION_SUCCESS',
    MANAGE_AUDITION_FAIL: 'MANAGE_AUDITION_FAIL',
};

export interface IGetAudition {
    auditionSlug: string;
    params: string;
}

export interface IAuditionInitialState {
    gettingAuditions: boolean;
    gettingAudtionDetails: boolean;
    auditionDetails?: IAudition;
    gettingAuditionError: null;
    /** Currently logged in user applications */
    applications: Array<IApplication>;
    gettingMyApplications: boolean;
    gettingMyApplicationsErrorMsg: null;
    withdrawingApplication: boolean;
    withdrawApplicationError: any;
    auditions: IAudition[];
    auditionFilters?: IAuditionFilter;
    filterMode: boolean;
    showFilter: boolean;
    savedRoles: IRole[];
    savedAuditions: ISavedAudition[];
    savedContests: IContestWatchList[];
    gettingSavedRoles: boolean;
    savingRole: boolean;
    gettingSavedRolesError: any;
    savingRoleErrorMsg: any;
    deletingSavedCollection: boolean;
    updatingSavedCollection: boolean;
    userAuditions: IAudition[];
    similarAuditions: IAudition[];
    gettingSimilarAuditions?: boolean;
    gettingUserAuditions: boolean;
    creatingAuditionMode: boolean;
    currentAuditionInCreation: CurrentAuditionInCreation;
    currentAuditionRolesInCreation: Array<IRole>;
    creatingAuditionError: null;
    creatingRolesError: null;
    creatingInProcess: boolean;
    unPublishing: boolean;
    deletingAudition: boolean;
    deletingAuditionErrorMsg: null;
    uploadProgress: string;
    currentManagedAudition?: IAudition | undefined;
    currentManagedApplications: Array<IApplication>;
    gettingAuditionApplications: boolean;
    sortingApplication: boolean;
    sorter: Sorter;
    searchResults: Array<IAudition>;
    currentAuditionPage: number;
    currentAuditionLimit: number;
    loadingMore?: boolean;
    loadingMoreErr?: any;
    castingDirector?: ICastingDirector[];
    gettingCastingDirector?: boolean;
    creatingCastingDirector?: boolean;
    selectedRole?: IRoleData;
    totalResult: number;
    canLoadMore?: boolean;
    currentManagedRoles?: IRole[];
    managedAuditionWithSubmissions: IAudition | null;
    managingAuditionWithSubmissions: boolean;
    managingAuditionWithSubmissionsError: any | null;
    managedAuditionPagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
    };
    searching?: boolean;
    updatingAudition?: boolean;
    /** Thspian user ids for brand curated invites: kept until create succeeds (or overwritten on next submit) so retries still merge. */
    pendingBrandCuratedInviteUserIds: string[];
}

type Sorter = { [status in FilingStatus]: Array<IApplication> };
export type AuditionDetails = {
    selectedAudition?: IAudition;
    roles: Array<IRole>;
    gettingAuditionRoles: boolean;
    gettingAuditionRolesErrorMsg: any;
};

export type Location = {
    type?: string;
    coordinates?: Array<number>;
    address?: string;
    description?: string;
};
export type AuditionFilter = {
    required_skill: string;
    required_media: string;
    age_range: string;
    filming_location: Location;
    rehearsal_date: string;
    compensation: string;
    audition_type: string;
    employment_type: string;
    tags: string;
};

type CurrentAuditionInCreation = {
    id: string;
    roles: Array<IAudition>;
};

export interface IGetSimilarAuditions {
    gig_type?: string;
    audition_type?: string;
    compensation?: string;
    premium_audition?: string;
    limit?: number;
    page?: number;
}

export type FilterLocation = {
    address: string;
    coordinates: {
        lat: number;
        lng: number;
    };
};

export type TAuditionFilter =
    | 'rehearsal_date_start'
    | 'rehearsal_date_end'
    | 'tags'
    | 'audition_type'
    | 'required_skill'
    | 'compensation'
    | 'talent_location'
    | 'job_start_date'
    | 'job_end_date'
    | 'gig_type'
    | 'is_feature'
    | 'employment_type'
    | 'min_age'
    | 'max_age'
    | 'shoot_location';

export type IAuditionFilter = {
    [key in TAuditionFilter]: {
        value: string | string[] | number | FilterLocation;
        displayValue: string[] | string;
    };
};

export interface ICreateCastingDirector {
    company_name: string;
    location: ILocation;
    profile_picture?: File[];
    demo_reel?: File[];
    gallery?: File[];
    about: string;
    date_of_formation?: string;
    singleRawFile?: any;
    rawFiles?: any;
}

export interface ICreateAuditionPayload
    extends Pick<IPostFormInitialState, 'scheduled_published_date' | 'publishStatus' | 'status'> {
    /** Client-only: Thspian user ids to invite after create/publish (brand curated talents). */
    brandCuratedInviteUserIds?: string[];
    imageCover: string;
    gig_type: FormOption;
    synopsis: string;
    production_company: ICastingDirector;
    attachment: string;
    submission_report: FormOption;
    role: IRole[];
    shoot_location: ILocation;
    talent_location: ILocation;
    casting_expiration: string;
    job_start_date: string;
    rehearsal_date: string;
    title: string;
    is_background_color?: boolean;
    background_color?: string;
    font_family?: string;
    tempImageCover?: string;
}

/**
 * PATCH payloads are sent as partial audition updates across the app.
 * Keep this broader than `ICreateAuditionPayload` because update forms submit
 * subsets and include additional persisted fields like plot/requirements/etc.
 */
export type IAuditionUpdatePayload = Partial<ICreateAuditionPayload> & Record<string, any>;

export interface IUpdateAudition {
    isImageUpload: boolean;
    id: string;
    body: IAuditionUpdatePayload;
    uploadStyle?: string;
    fromCreate?: boolean;
    withPublish?: boolean;
    createdRoles?: any[];
    /** Client-only: passed through create flow for post-publish invites. */
    brandCuratedInviteUserIds?: string[];
}

export interface IUpdateRole {
    /** Id of the role */
    id: string;
    body: IRoleCreator;
}

export interface IUpdateCastingDirector {
    id: string;
    body: any;
}

export interface IApplyToAudition {
    role: string;
    profile: string;
    note?: string;
    attached_media?: string[];
}

export interface IAuditionApplication {
    audition: string;
    role: string;
    profile: IWorkProfile;
    note?: string;
    attached_media?: IProject[];
    deleted: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface IManageAuditionParams {
    auditionId: string;
    page?: number;
    limit?: number;
    status?: string;
    sort?: string;
    search?: string;
    roleId?: string;
    isSearch?: boolean;
}

export interface IManageAuditionResponse {
    status: string;
    data: {
        pagination: IPaginator;
        audition: IAudition;
        applications: IApplication[];
    };
}
